import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { useTabs } from '../../contexts/TabContext';
import './TabManager.css';

const TabManager = () => {
  const { t } = useTranslation();
  const { tabs, activeTabId, activateTab, closeTab, closeOtherTabs } = useTabs();

  if (tabs.length === 0) {
    return null;
  }

  const handleTabClick = (e, tabId) => {
    e.preventDefault();
    activateTab(tabId);
  };

  const handleCloseClick = (e, tabId) => {
    e.preventDefault();
    e.stopPropagation();
    closeTab(tabId);
  };

  return (
    <div className="tabs tab-manager-wrapper">
      <ul className="nav nav-tabs">
        {tabs.map((tab) => (
          <li key={tab.id} className={activeTabId === tab.id ? 'active' : ''}>
            <a
              href={`#tab-${tab.id}`}
              onClick={(e) => handleTabClick(e, tab.id)}
              style={{ cursor: 'pointer' }}
              className="tab-manager-link"
            >
              <i className={`fa ${tab.icon}`}></i>
              <span className="tab-title">{t(tab.title)}</span>
              {tabs.length > 1 && (
                <button
                  className="tab-close"
                  onClick={(e) => handleCloseClick(e, tab.id)}
                  title={t('common.close')}
                >
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              )}
            </a>
          </li>
        ))}
        {tabs.length > 1 && (
          <li className="tab-actions-item">
            <button
              className="tab-action-btn"
              onClick={closeOtherTabs}
              title={t('tabs.closeOthers')}
            >
              <FontAwesomeIcon icon={faTimesCircle} />
            </button>
          </li>
        )}
      </ul>
    </div>
  );
};

export default TabManager;

